import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "@/components/motion";
import { SectionLabel } from "@/components/shared";
import { GALLERY } from "@/data/site";

export default function Camps() {
  const spans = [
    "sm:col-span-2 sm:row-span-2",
    "", "", "",
    "sm:col-span-2",
    "", "", "",
    "sm:col-span-2",
  ];
  return (
    <div data-testid="camps-page">
      <section className="relative overflow-hidden pb-16 pt-40 md:pt-48" data-testid="camps-hero">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <SectionLabel>Camps & Gallery</SectionLabel>
          <h1 className="font-heading text-6xl uppercase leading-[0.82] tracking-tight text-white sm:text-8xl lg:text-[8rem]">
            <MaskLines lines={["Inside The", <span className="text-neon-green">Camps</span>]} />
          </h1>
          <Reveal delay={0.6}>
            <p className="mt-8 max-w-2xl font-body text-lg leading-relaxed text-white/70 md:text-xl">
              A look at ARD Midsouth Performance on the pitch.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative z-10 bg-obsidian py-16 md:py-24" data-testid="camps-gallery">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="grid auto-rows-[220px] grid-cols-2 gap-4 sm:grid-cols-4 md:auto-rows-[280px]">
            {GALLERY.map((src, i) => (
              <Reveal key={i} delay={(i % 4) * 0.06} className={`group relative overflow-hidden border border-white/10 ${spans[i % spans.length]}`}>
                <img src={src} alt={`ARD camp photo ${i + 1}`} className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105" />
                <div className="absolute inset-0 bg-neon-green/0 transition-colors duration-500 group-hover:bg-neon-green/15" />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative z-10 bg-surface py-20 text-center md:py-28" data-testid="camps-cta">
        <div className="mx-auto max-w-3xl px-5">
          <h2 className="font-heading text-4xl uppercase leading-none tracking-tight text-white sm:text-6xl">
            Want To Be In The Next Photo?
          </h2>
          <Link to="/register" data-testid="camps-register-btn" className="mt-8 inline-flex items-center gap-2 bg-neon-green px-10 py-5 font-heading text-lg uppercase tracking-widest text-black">
            Sign Up For Training
            <ArrowUpRight size={22} strokeWidth={3} />
          </Link>
        </div>
      </section>
    </div>
  );
}
